export enum ProviderShopDeliveryType {
    DelivererFullHandled = 1,
    SeparatedPickingAndDelivery = 2,
    OnlyDelivery = 3,
}
